module.exports = __webpack_public_path__ + "static/media/Nigeria Social Insurance Trust Fund.6c3d9147.png";